export const shepherdToursActions = {
    SET_SHEPHERD_TOURS: 'SET_SHEPHERD_TOURS',
    SET_SHEPHERD_SECTIONS: 'SET_SHEPHERD_SECTIONS',
    SET_SHEPHERD_TOUR_PROGRESS: 'SET_SHEPHERD_TOUR_PROGRESS'
}

const initState = {
    progress: 0,
    tours: [],
    sections: []
}

export const shepherdToursReducer = (state = initState, action: any) => {
    switch (action.type) {
        case shepherdToursActions.SET_SHEPHERD_TOURS:
        case shepherdToursActions.SET_SHEPHERD_SECTIONS:
        case shepherdToursActions.SET_SHEPHERD_TOUR_PROGRESS:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/shepherdToursReducer.ts